import { gql } from '@apollo/client';

export const GET_SCENES = gql`
    query GetScenes {
        getScenes {
            sceneId
            renderers {
                rendererId
                pages {
                    pageId
                    layers {
                        layerId
                        captions {
                            captionId
                            dimension {
                                width
                                height
                            }
                            position {
                                x
                                y
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const GET_COMMANDS = gql`
    query myQuery($renderer: String!) {
    getCommands(renderer: $renderer) {
            renderer
            layer
            updatedAt
            GPI
            DataConnector
            caption {
                id        
                action
                mode        
                option {            
                    id            
                    value        
                }        
                data
            }
    }
}

`;

export const GET_INITIAL_COMMANDS = gql`
    query myQuery ($renderer: String!) {
        getInitialCommands(renderer: $renderer) {
            eventId
            data {
                team {
                    home {
                        tricode
                        kitType
                    }
                    away {
                        tricode
                        kitType
                    }
                }
            }
            renderer
            scenePath
        }
    }
`;

// State report, not a command: flips the stored caption row (e.g. a scene
// auto-OUT) without publishing anything to subscribers or renderers.
export const SYNC_CAPTION_STATE = gql`
    mutation SyncCaptionState($payload: SyncCaptionStateInput) {
        syncCaptionState(payload: $payload)
    }
`;

export const GET_PAGE = gql`
query GetScenes($pageId: String!) {
    getPage(pageId: $pageId) {
        sceneId
        renderers {
            rendererId
            pages {
                pageId
                layers {
                    layerId
                    captions {
                        captionId
                        dimension {
                            width
                            height
                        }
                        position {
                            x
                            y
                        }
                    }
                }
            }
        }
    }
}`;